import React from "react";
import { Routes, Route } from "react-router-dom";
import HazMatInspectionList from "./HazMatInspectionList";
import HazMatInspectionDetail from "./HazMatInspectionDetail";

const InspectionAndCompliance: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<HazMatInspectionList />} />
      <Route path="/view/:inspectionId" element={<HazMatInspectionDetail />} />
    </Routes>
  );
};

export default InspectionAndCompliance;
